import liveChatModule from '../liveChat.module';

class LiveChatService {
    constructor(
        __env,
        $q,
        $window,
        accountProvider,
        scriptUtil,
        stateConstants,
        userAccessService
    ) {
        this.__env = __env;
        this.$q = $q;
        this.$window = $window;
        this.accountProvider = accountProvider;
        this.scriptUtil = scriptUtil;
        this.stateConstants = stateConstants;
        this.userAccessService = userAccessService;

        this.cache = {};
        this.promiseCache = {};
    }

    getClientApi() {
        if (this.cache.clientApi) {
            return this.$q.resolve(this.cache.clientApi);
        }

        if (!this.__env.chatJsUrl) {
            return this.$q.reject();
        }

        let promiseId = 'getClientApi';
        if (this.promiseCache[promiseId]) {
            return this.promiseCache[promiseId].promise;
        }

        let deferred = this.$q.defer();
        this.promiseCache[promiseId] = deferred;

        this.userAccessService
            .hasAccessTo(this.stateConstants.support.overview.name)
            .then(
                hasAccess => {
                    if (hasAccess) {
                        this.scriptUtil
                            .loadScript(this.__env.chatJsUrl)
                            .then(() => {
                                if (this.$window.ChatAPI) {
                                    this.cache.clientApi = this.$window.ChatAPI;
                                    deferred.resolve(this.$window.ChatAPI);

                                    return;
                                }

                                deferred.reject();
                            }, deferred.reject);

                        return;
                    }

                    deferred.resolve();
                },
                () => {
                    console.log(
                        'liveChatService.getClientApi: Failed to get user access.'
                    );
                }
            );

        return deferred.promise;
    }

    initiateChat() {
        let promises = [this.getClientApi(), this.getContext()];

        this.$q.all(promises).then(
            data => {
                let api = data[0];

                if (api) {
                    let context = data[1];

                    api.setChatContext(context);
                    api.initiateChat();
                }
            },
            () => {
                console.log(
                    'liveChatService.initiateChat: Failed to get client api and context.'
                );
            }
        );
    }

    getContext() {
        if (this.cache.context) {
            return this.$q.resolve(this.cache.context);
        }

        let deferred = this.$q.defer();
        let promises = [
            this.accountProvider.getAccountUserInfo(),
            this.accountProvider.getUser()
        ];

        this.$q.all(promises).then(
            data => {
                let accountUserInfo = data[0];
                let user = data[1];

                let context = {
                    accountId: accountUserInfo.aan,
                    userId: user.username,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    caseId: undefined
                };

                this.cache.context = context;

                deferred.resolve(context);
            },
            () => {
                console.log(
                    'liveChatService.getContext: Failed to get account user info and user.'
                );
                deferred.reject();
            }
        );

        return deferred.promise;
    }

    setCaseId(caseId) {
        this.getContext().then(
            data => {
                if (data) {
                    this.cache.context.caseId = caseId;
                }
            },
            () => {
                console.log(
                    'liveChatService.setCaseId: Failed to get context.'
                );
            }
        );
    }
}

export default liveChatModule.service('liveChatService', LiveChatService);



// WEBPACK FOOTER //
// ./modules/liveChat/services/liveChat.service.js